(() => {
  const sticky = document.querySelector('[data-mf-sticky-atc]');
  if (!sticky || sticky.dataset.initialized) return;
  sticky.dataset.initialized = 'true';

  const priceElement = sticky.querySelector('[data-sticky-price]');
  const compareElement = sticky.querySelector('[data-sticky-compare-price]');
  const imageElement = sticky.querySelector('[data-sticky-image]');
  const addButton = sticky.querySelector('[data-sticky-add]');
  const buttonLabel = sticky.querySelector('[data-sticky-button-label]');
  const closeButton = sticky.querySelector('#mfStickyAtcClose');
  const currencyCode = sticky.dataset.currencyCode || 'CAD';
  const currencySymbol = sticky.dataset.currencySymbol || '$';

  let variants;

  try {
    variants = JSON.parse(sticky.dataset.variantData || '[]');
  } catch (error) {
    console.error('Unable to read sticky add-to-cart variant data.', error);
    return;
  }

  const formatMoney = (cents) => {
    const number = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cents) / 100);

    return `${currencySymbol}${number} ${currencyCode}`;
  };

  const findProductForm = () => {
    const productInfo = sticky.closest('product-info');
    return productInfo?.querySelector('form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
  };

  const findSelectedVariantId = () => {
    const form = findProductForm();
    return form?.querySelector('input[name="id"]')?.value || sticky.dataset.variantId;
  };

  const updateStickyVariant = () => {
    const variantId = String(findSelectedVariantId());
    const variant = variants.find((item) => String(item.id) === variantId);

    if (!variant) return;

    const isAvailable = Boolean(variant.available);
    const hasComparePrice = Number(variant.compare_at_price) > Number(variant.price);

    if (priceElement) {
      priceElement.textContent = formatMoney(variant.price);
    }

    if (compareElement) {
      compareElement.classList.toggle('is-hidden', !hasComparePrice);
      compareElement.innerHTML = hasComparePrice
        ? `<span class="visually-hidden">Regular price:</span>${formatMoney(variant.compare_at_price)}`
        : '';
    }

    if (imageElement && variant.featured_image?.src) {
      imageElement.src = `${variant.featured_image.src}&width=120`;
      imageElement.alt = variant.featured_image.alt || '';
    }

    if (addButton) {
      addButton.disabled = !isAvailable;
    }

    if (buttonLabel) {
      buttonLabel.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }

    sticky.dataset.variantId = variant.id;
  };

  addButton?.addEventListener('click', () => {
    const form = findProductForm();
    const nativeAddButton = form?.querySelector('[name="add"]');

    if (nativeAddButton) {
      nativeAddButton.click();
      return;
    }

    if (!form) return;

    const formData = new FormData(form);
    formData.set('id', findSelectedVariantId());

    fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(() => {
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    });
  });

  closeButton?.addEventListener('click', () => {
    sticky.hidden = true;
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('variant-selects select, variant-radios input, input[name="id"]')) {
      window.setTimeout(updateStickyVariant, 0);
    }
  });

  document.addEventListener('variant:change', updateStickyVariant);
  document.addEventListener('shopify:section:load', updateStickyVariant);

  updateStickyVariant();
})();
